import { withSentryReactRouterV7Routing } from "@sentry/react";
import View from "./views/view";
import { Routes, Route } from "react-router";

const SentryRoutes = withSentryReactRouterV7Routing(Routes);

export default function App() {
  return (
    <SentryRoutes>
      <Route path="/" element={<View />} />
    </SentryRoutes>
  );
}
